import React from "react";

const Pagination = ({ page, totalPages, onChange }) => (
  <div className="flex items-center justify-end gap-3 mt-4 text-sm">
    <button
      onClick={() => onChange(page - 1)}
      disabled={page <= 1}
      className="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 disabled:opacity-50"
    >
      Prev
    </button>
    <span>
      {page} / {totalPages}
    </span>
    <button
      onClick={() => onChange(page + 1)}
      disabled={page >= totalPages}
      className="px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 disabled:opacity-50"
    >
      Next
    </button>
  </div>
);

export default Pagination;
